import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Particle from '../Particle';
import ResumeContent from './ResumeContent';

function Resume(props) {
	let english = {
		"job_exp": "Job Experience",
		"job3_title": "Junior Front-end Developer in Oponeo.pl S.A., Bydgoszcz, Poland",
		"job3_date": "March 2021 - Now",
		"job3_content": [],
		"job2_title": "Graphic Designer in MRzepa Sport Mirosław Rzepa, Bydgoszcz, Poland",
		"job2_date": "October 2018 - February 2021",
		"job2_content": [
			'Designing new patterns for sports clothes.',
			'Making prints on clothing (mainly sports clothing).',
			'Working with large format printers and plotters.',
			'Updating and maintaining the company\'s website in Wordpress.'
		],
		"job1_title": "Internship at Artcop, Bydgoszcz, Poland",
		"job1_date": "July 2017 - August 2017",
		"job1_content": [
			'Creating website for the company.',
			'Local computer network management.',
			'Working with printers and plotters.'
		],
		"languages": "Languages",
		"lang_polish": "Polish: Native",
		"lang_english": "English: Intermediate",
		"lang_german": "German: Basic",
		"education": "Education",
		"edu1_title": "University of Science and Technology in Bydgoszcz",
		"edu1_date": "October 2020 - Now",
		"edu1_content": [
			'Field of study: Applied Computer Science',
			'Master\'s degree'
		],
		"edu2_title": "University of Science and Technology in Bydgoszcz",
		"edu2_date": "October 2015 - April 2020",
		"edu2_content": ['Field of study: Applied Computer Science',
			'Bachelor\'s degree'
		]
	};

	let polish = {
		"job_exp": "Doświadczenie zawodowe",
		"job3_title": "Młodszy Front-end Developer w Oponeo.pl S.A., Bydgoszcz, Polska",
		"job3_date": "Marzec 2021 - Obecnie",
		"job3_content": [],
		"job2_title": "Grafik w MRzepa Sport Mirosław Rzepa,\n Bydgoszcz, Polska",
		"job2_date": "Październik 2018 - Luty 2021",
		"job2_content": [
			'Projektowanie nowych wzorów na stroje sportowe.',
			'Wykonywanie nadruków na odzieży (sportowej).',
			'Obsługa drukarek wielkoformatowych i ploterów.',
			'Aktualizowanie i utrzymywanie strony internetowej firmy w Wordpressie.'
		],
		"job1_title": "Praktyki w Artcop, Bydgoszcz, Polska",
		"job1_date": "Lipiec 2017 - Wrzesień 2017",
		"job1_content": [
			'Tworzenie strony internetowej na potrzeby firmy.',
			'Zarządzanie lokalną siecią komputerową.',
			'Obsługa drukarek i ploterów.'
		],
		"languages": "Znajomość języków",
		"lang_polish": "Polski: Ojczysty",
		"lang_english": "Angielski: Średnio zaawansowany",
		"lang_german": "Niemiecki: Podstawowy",
		"education": "Edukacja",
		"edu1_title": "Uniwersytet Technologiczno-Przyrodniczy w Bydgoszczy",
		"edu1_date": "Październik 2020 - Obecnie",
		"edu1_content": [
			'Kierunek studiów: Informatyka Stosowana',
			'Tytuł: Magister inżynier'
		],
		"edu2_title": "Uniwersytet Technologiczno-Przyrodniczy w Bydgoszczy",
		"edu2_date": "Październik 2015 - Kwiecień 2020",
		"edu2_content": [
			'Kierunek studiów: Informatyka Stosowana',
			'Tytuł: Inżynier'
		]
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<Container fluid className='resume-section'>
			<Particle />
			<Container>
				<Row className='resume'>
					<Col md={6} className='resume-left'>
						<h3 className='resume-title'>{language.job_exp}</h3>
						<ResumeContent
							title={language.job3_title}
							date={language.job3_date}
							content={language.job3_content}
							style={{ paddingBottom: '30px' }}
						/>
						<ResumeContent
							title={language.job2_title}
							date={language.job2_date}
							content={language.job2_content}
							style={{ paddingBottom: '30px' }}
						/>
						<ResumeContent
							title={language.job1_title}
							date={language.job1_date}
							content={language.job1_content}
							style={{ paddingBottom: '10px' }}
						/>
					</Col>
					<Col md={6} className='resume-right'>
						<h3 className='resume-title'>{language.education}</h3>
						<ResumeContent
							title={language.edu1_title}
							date={language.edu1_date}
							content={language.edu1_content}
						/>
						<ResumeContent
							title={language.edu2_title}
							date={language.edu2_date}
							content={language.edu2_content}
						/>
						<h3 className='resume-title'>{language.languages}</h3>
						<div className='resume-item'>
							<ul>
								<li style={props.title ? {} : { fontSize: '18px' }}> ‣ {language.lang_polish}</li>
							</ul>
						</div>
						<div className='resume-item'>
							<ul>
								<li style={props.title ? {} : { fontSize: '18px' }}> ‣ {language.lang_english}</li>
							</ul>
						</div>
						<div className='resume-item'>
							<ul>
								<li style={props.title ? {} : { fontSize: '18px', paddingBottom: '30px' }}> ‣ {language.lang_german}</li>
							</ul>
						</div>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}

export default Resume;
